// Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase,
// DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper,
// SplitText, CustomBounce, CustomWiggle,
import { gsap, ScrollTrigger } from "gsap/all";
import initOrnaments from "/assets/scripts/ornaments.js";

gsap.registerPlugin(ScrollTrigger);
export default () => {
  let mm = gsap.matchMedia();
  //------------------------------------------------------//
  // Setup 🧦 GSAP and register 📜 ScrollTrigger
  // Register more plugins like so: gsap.registerPlugin(ScrollTrigger, splitText);
  // Go to https://greensock.com/docs/v3/Installation?checked=core,scrollTrigger,splitText#installer
  //------------------------------------------------------//
  // gsap.registerPlugin(Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase, DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper, SplitText, CustomBounce, CustomWiggle);

  ScrollTrigger.defaults({
    toggleActions: "restart pause resume pause",
    markers: window.location.hostname.endsWith(".local") ? true : false,
  });

  // END Setup 🧦 GSAP -------------------------------------//

  initOrnaments();
  //--------------------------------//
  // 404 
  //--------------------------------//
  const page404 = document.querySelector("body.error404");

  if (page404) {
    const stage = document.querySelector(".stage");
    const cards = gsap.utils.toArray(".card");
    const shapes = gsap.utils.toArray(".shape");

    if (stage && cards.length && shapes.length) {
      gsap.set(shapes, {
        backgroundColor: "random([#4134AA, #63F193, #5f50d1])",
      });

      stage.addEventListener("mousemove", (e) => {
        const radius = 500;
        const maxScale = 2.5;
        const dur = 0.5;
        cards.forEach((card) => {
          const r = card.getBoundingClientRect();
          const d = Math.hypot(
            e.clientX - (r.left + r.width / 2),
            e.clientY - (r.top + r.height / 2)
          );
          const p = gsap.utils.clamp(0, 1,
            gsap.utils.mapRange(0, radius, 1, 0, d)
          );

          gsap.to(card, {
            scale: 1 + (maxScale - 1) * p,
            duration: dur,
            overwrite: true,
            ease: "power2.out"
          });
        });
      });
    }
  }
  // END 404 --------------//


};
